'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _companyEditForm = require('./company-edit-form.component');

var _companyEditForm2 = _interopRequireDefault(_companyEditForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.admin.company.company-edit-form', []).component('companyEditForm', _companyEditForm2.default).name;


// WEBPACK FOOTER //
// ./components/app/admin/company/company-edit-form/company-edit-form.module.js